export default {
    'this-request': 'this request',
    'viewed-requests': 'Viewed requests',
    'delete-request': 'delete request',
    'the-request-is': 'The request is',
    'accepted': 'accepted',
    'rejected': 'rejected',
    'confirm-acceptance': 'Confirm acceptance',
    'confirm-rejection': 'Confirm rejection',
    'the-request': 'the request'
}